import { z } from "zod";

export const TableConfigSchema = z.object({
	id: z.number(),
	listId: z.number().optional().nullable(),
	trackerId: z.number().optional().nullable(),
	config: z.any(),
});

export type TableConfig = z.infer<typeof TableConfigSchema>;
